import { serialize } from 'cerialize'

export class PlatformCreateRequest {
  @serialize name: string;

  constructor(name: string) {
    this.name = name
  }
}